const PlayerToggle = ({ active, onChange, disabled }) => (
  <button
    onClick={() => !disabled && onChange(!active)}
    disabled={disabled}
    title={active ? 'Убрать из турнира' : 'Вернуть в турнир'}
    style={{
      position: 'relative', width: 40, height: 22, borderRadius: 11,
      background: active ? '#16a34a' : '#d1d5db',
      border: 'none', padding: 0, flexShrink: 0,
      cursor: disabled ? 'not-allowed' : 'pointer',
      transition: 'background 0.2s',
    }}
  >
    <span style={{
      position: 'absolute', top: 2, left: active ? 20 : 2,
      width: 18, height: 18, borderRadius: '50%', background: '#fff',
      boxShadow: '0 1px 3px rgba(0,0,0,0.25)', transition: 'left 0.2s',
    }} />
  </button>
);

export default PlayerToggle;
